module.exports = __webpack_public_path__ + "img/campaignImage2.a9c41f09.png";